/** English UI strings for /article-submit (form labels, steps, errors). */

export const articleSubmitEn = {
  progress: {
    step1: 'Article Info',
    step2: 'Authors',
    step3: 'Upload Files',
    step4: 'Complete',
  },
  buttons: {
    previous: 'Previous',
    next: 'Next',
    submit: 'Submit Article',
    submitting: 'Submitting...',
    dashboard: 'Go to Dashboard',
    addAuthor: '+ Add Another Author',
    remove: 'Remove',
    choosePdf: 'Choose PDF File',
  },
  errors: {
    pdfOnly: 'Please upload a PDF file',
    enTitleRequired: 'English title is required',
    enAnnotationRequired: 'English annotation is required',
    keywordsRequired: 'Keywords are required',
    sectionRequired: 'Please select a section',
    authorFirstLast: 'Author {num}: First and last name are required',
    authorEmail: 'Author {num}: Email is required',
    authorAffiliation: 'Author {num}: Affiliation is required',
    correspondingRequired: 'At least one corresponding author is required',
    manuscriptRequired: 'Please upload manuscript file (PDF)',
    submitFailed: 'Failed to submit article. Please try again.',
  },
  step1: {
    title: 'Article Information',
    enBlockTitle: 'English (Required)',
    labelEnTitle: 'Title',
    phEnTitle: 'Enter article title in English',
    labelEnAbstract: 'Abstract',
    phEnAbstract: 'Enter abstract (150-250 words)',
    labelEnKeywordsField: 'Keywords',
    phEnKeywordsField: 'Enter main content or keywords',
    ruBlockTitle: 'Русский (Russian)',
    labelRuTitle: 'Название',
    phRuTitle: 'Введите название статьи на русском',
    labelRuAbstract: 'Аннотация',
    phRuAbstract: 'Введите аннотацию',
    uzBlockTitle: "O'zbekcha (Uzbek)",
    labelUzTitle: 'Sarlavha',
    phUzTitle: 'Maqola sarlavhasini kiriting',
    labelUzAbstract: 'Annotatsiya',
    phUzAbstract: 'Annotatsiyani kiriting',
    keywordsLabel: 'Keywords',
    keywordsPlaceholder: 'e.g., Machine Learning, AI, Data Science',
    sectionLabel: 'Section',
    sectionPlaceholder: 'Select section',
    sectionComputerScience: 'Computer Science',
    sectionEngineering: 'Engineering',
    sectionMathematics: 'Mathematics',
    sectionPhysics: 'Physics',
    sectionOther: 'Other',
    submissionTypeLabel: 'Submission Type',
    submissionJournalOnly: 'Journal Only',
    submissionConferenceOnly: 'Conference Only',
    submissionBoth: 'Both Journal & Conference',
    pageCountLabel: 'Page Count',
    pageCountPlaceholder: 'Number of pages',
  },
  step2: {
    title: 'Author Information',
    authorHeading: 'Author {num}',
    labelFirstName: 'First Name',
    phFirstName: 'First name',
    labelLastName: 'Last Name',
    phLastName: 'Last name',
    labelEmail: 'Email',
    phEmail: 'email@example.com',
    labelOrcid: 'ORCID iD',
    phOrcid: '0000-0000-0000-0000',
    labelCountry: 'Country',
    countryPlaceholder: 'Select country',
    countryUzbekistan: 'Uzbekistan',
    countryRussia: 'Russia',
    countryKazakhstan: 'Kazakhstan',
    countryUSA: 'United States',
    countryGermany: 'Germany',
    countryOther: 'Other',
    labelAffiliation: 'Affiliation',
    affiliationPlaceholder: 'Select affiliation',
    labelDepartment: 'Department/Faculty',
    phDepartment: 'e.g., Computer Science Department',
    correspondingAuthor: 'Corresponding Author',
  },
  step3: {
    title: 'Upload Files',
    manuscriptTitle: 'Manuscript File',
    manuscriptHint:
      'Upload your manuscript in PDF format (without author names for blind review)',
    coverTitle: 'Cover Letter (Optional)',
    coverHint: 'Upload a cover letter explaining the significance of your work',
    guidelinesTitle: 'Submission Guidelines:',
    g1: 'Manuscript must be in PDF format',
    g2: 'Remove all author identifying information',
    g3: 'Follow the journal template',
    g4: 'Include all figures and tables',
    g5: 'Maximum file size: 10MB',
  },
  step4: {
    successTitle: 'Article Submitted Successfully!',
    successP:
      'Your article has been submitted and is now under review. You will receive an email confirmation shortly.',
    whatsNext: "What's next?",
    next1: 'Editorial team will conduct initial review',
    next2: 'Article will be sent for peer review',
    next3: "You'll receive feedback within 4-6 weeks",
    next4: 'Track your submission status in your dashboard',
  },
};
